<div class="float-drag" cdkDrag>
	<div class="float-container" cdkDragHandle>
        <div class="float-header" >
			<div class="header-text">Centerline Edit</div>
			<i class="glyphicons glyphicons-remove" (click)="close()"></i>
        </div>
	
		<div class="wizard-content-wrap-columns">
			<div class="wizard-step-container">
				<ng-container *ngFor="let step of steps">
					<div *ngIf="step.num <= currentStep.num" [@fadeInOut] [ngClass]="{'step-title-line': step.isSameLine}">
						<app-wizard-step-title [stepNum]="step.num" [stepLabel]="step.label" [isCurrent]="step.num===currentStep.num"></app-wizard-step-title>
						<div *ngIf="step.prop==='selectAction'" class="action-item">
							<div *ngFor="let ac of actions" class="same-line">
								<input name="currentAction" type="radio" [value]="ac.prop" [(ngModel)]="currentAction" (ngModelChange)="onSelectAction()">
								<div>{{ac.label}}</div>
							</div>
						</div>
						<div *ngIf="step.prop==='pickLine'&&currentAction!=='delete'" class="action-item">
							<!-- <mat-icon class="icon-general topo-icon" svgIcon="icon-topology-ring" [ngClass]="{'icon-off': !isNetworkTopoOn}" (click)="toggleNetworkTopoMode()"></mat-icon> -->
							<!-- <mat-slide-toggle
								class="unbiased-slide-toggle"
								[(ngModel)]="isNetworkTopoOn"
								(change)="toggleNetworkTopoMode()">
							</mat-slide-toggle> -->
							<input type="checkbox" name="topoCheckbox" [(ngModel)]="isNetworkTopoOn" (ngModelChange)="toggleNetworkTopoMode()">
							<label>Network Topology</label>
						</div>
					</div>
				</ng-container>
			</div>
	
			<div class="wizard-button-groups">
				<div style="flex-grow:1;margin-bottom: 10px;">
					<button class="button-general button-small" (click)="cancel()">Cancel</button>
				</div>
				<button class="button-general button-small" [disabled]="checkAddCardsDisabled(currentStep.prop)" (click)="addCards()">Add Cards</button>
			</div>
		</div>
	</div>
</div>